"use client";
import Image from "next/image";
import Link from "next/link";

import { Metadata } from "next";
import { Button } from "@/components/ui/button";
import { useAssets, useHref } from "@/lib/utils";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import React from "react";
import { useTranslations } from "next-intl";

export default function Hero() {
  const t = useTranslations("Profile.Hero");
  const href = useHref();
  const asset = useAssets();
  return (
    <section className="mx-4 lg:mx-0">
      <div className="bx-container bg-[#0C111D] rounded-lg lg:rounded-3xl w-full text-white p-5 lg:p-20 flex flex-col items-center justify-center relative mb-20">
        <p className="text-[#667085] text-lg font-extrabold tracking-wider mb-4 ">
          {t("title")}
        </p>
        <h1 className="text-xl md:text-4xl font-black max-w-full text-inherit text-center">
          {t("subtitle")} <br />
          <span className="text-[#F5BE01]">{t("highlihtedSubtitle")}</span>
        </h1>
        <p className="mt-10 mx-auto text-[#D0D5DD] text-sm lg:text-base font-normal leading-5 lg:leading-9 text-center">
          {t("description")}
        </p>
        <Image
          src={asset.ornamentChickentFoot}
          alt="ornament-7"
          className="absolute top-0 left-0 pointer-events-none"
        />

        <Dialog>
          <DialogTrigger>
            <span className="btn-comfortable gap-2 text-[#0C111D] mt-10 from-[#F5BE01] to-[#FFDF72] bg-gradient-to-b border border-[#F5BE01] transitional-all ease-in-out duration-75 h-10 px-4 py-2 inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
              <svg
                width="25"
                height="24"
                className="text-transparent"
                viewBox="0 0 25 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2281_1746)">
                  <path
                    d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10 8.96533C10 8.48805 10 8.24941 10.0997 8.11618C10.1867 8.00007 10.3197 7.92744 10.4644 7.9171C10.6304 7.90525 10.8311 8.03429 11.2326 8.29239L15.9532 11.3271C16.3016 11.551 16.4758 11.663 16.5359 11.8054C16.5885 11.9298 16.5885 12.0702 16.5359 12.1946C16.4758 12.337 16.3016 12.449 15.9532 12.6729L11.2326 15.7076C10.8311 15.9657 10.6304 16.0948 10.4644 16.0829C10.3197 16.0726 10.1867 15.9999 10.0997 15.8838C10 15.7506 10 15.512 10 15.0347V8.96533Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2281_1746">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
              {t("btnTentangBx")}
            </span>
          </DialogTrigger>

          <DialogContent className="flex justify-center items-center flex-col max-w-screen-md lg:max-w-screen-xl ">
            <iframe
              src="https://www.youtube-nocookie.com/embed/MLtvP_-yl0o?si=5TRhRLzPUR_ipJXN"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="aspect-video w-full"
            ></iframe>
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
}
